<script>
    import { onMount } from "svelte";
    import { isLoading, locale } from "../stores.js";

    import { fetchGet } from "../utils/utilsFetch.js";

    import { getLocaleResource } from "../utils/locales.js";

    let data, canvasElement;

    onMount(async () => {
        $isLoading = true;

        data = await fetchGet(`/api/users`);

        let chartData = await fetchGet(`/api/orders-chart`);

        let periods = chartData.map((item) => item.ym);
        let revenues = chartData.map((item) => item.value);

        let context = canvasElement.getContext("2d");
        new Chart(context, {
            type: "bar",
            data: {
                labels: periods,
                datasets: [
                    {
                        data: revenues,
                        label: getLocaleResource($locale, "revenue"),
                        backgroundColor: "black",
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: true,
                    text: getLocaleResource($locale, "revenueMonthly"),
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItems, data) {
                            return tooltipItems.value.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                            );
                        },
                    },
                },
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                        },
                    ],
                    yAxes: [
                        {
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                callback: function (value, index, values) {
                                    if (parseInt(value) >= 1000) {
                                        return value
                                            .toString()
                                            .replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ","
                                            );
                                    } else {
                                        return value;
                                    }
                                },
                            },
                        },
                    ],
                },
            },
        });

        $isLoading = false;
    });
</script>

<svelte:head>
    <script
        type="text/javascript"
        src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.3/Chart.min.js"
    >
    </script>

    <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.3/Chart.min.css"
    />
</svelte:head>

<div class="container">
    <div class="content">
        <canvas class="chart" bind:this={canvasElement} />
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: 1fr;
        /* calc sprecuva tabelata da ide nadvor od content*/
        /* grid-template-rows: 30px 45px calc(100vh - 95px);  */
        grid-template-rows: auto 1fr;
        height: 100%;
    }

    .header {
        grid-row: 1/2;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        /* background: #ccc; */
        padding: 10px;
    }

    .header div {
        margin-right: 20px;
    }

    .content {
        padding: 0px 10px 10px 10px;
        grid-row: 2/-1;

        overflow: auto;
    }

    .user div {
        margin-bottom: 10px;
    }

    .form {
        display: flex;
        flex-direction: column;
    }

    .form input {
        margin-bottom: 10px;
    }
</style>
